// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// Define a service using a base URL and expected endpoints
export const homeData = createApi({
  reducerPath: "homeApi",
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API_URL }),
  endpoints: (builder) => ({
    getAchievers: builder.query({
      query: () => `achievers`,
      transformResponse: (response, meta, arg) => response.data,
    }),
    getDemoLectures: builder.query({
      query: (id) => ({
        url: `demo_lecture`,
        params: { course_id: id },
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    getPopularCourses: builder.query({
      query: ({ batchID, learningMode, classID }) => ({
        url: `popular_course`,
        params: {
          batch_id: batchID,
          learning_mode: learningMode,
          class_id: classID,
        },
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    getCommunity: builder.query({
      query: () => ({
        url: `get_community`,
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    getSixPillars: builder.query({
      query: () => ({
        url: `six_pillar`,
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    getLearnWithEdnovate: builder.query({
      query: () => ({
        url: `learn_with_ednovate`,
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    getAnnouncements: builder.query({
      query: () => ({
        url: `announcement`,
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    getLandingHeader: builder.query({
      query: () => ({
        url: `landing_header`,
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    getSectionHeadings: builder.query({
      query: () => ({
        url: `get_available`,
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    getBatchClass: builder.query({
      query: (batchID) => ({
        url: `get_batch_class`,
        params: {
          batch_id: batchID,
        },
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    getRailwayZones: builder.query({
      query: () => ({
        url: `railway_zone`,
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    getZoneBranches: builder.query({
      query: (zone_id) => ({
        url: `zone_branch`,
        params: {
          zone_id,
        },
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    getBranchZones: builder.query({
      query: () => ({
        url: `branch_zone`,
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    getOutsideZoneBranchs: builder.query({
      query: () => ({
        url: `outside_branch`,
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAchieversQuery,
  useGetDemoLecturesQuery,
  useGetPopularCoursesQuery,
  useGetCommunityQuery,
  useGetSixPillarsQuery,
  useGetLearnWithEdnovateQuery,
  useGetAnnouncementsQuery,
  useGetLandingHeaderQuery,
  useGetSectionHeadingsQuery,
  useGetBatchClassQuery,
  useGetRailwayZonesQuery,
  useGetZoneBranchesQuery,
  useGetBranchZonesQuery,
  useGetOutsideZoneBranchsQuery,
} = homeData;
